import { FullDate } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { removeMaskSpaces } from '@sravni/cosago-react-library/lib/utils';

export const DateField: FC<IFieldFactoryProps> = (props) => {
  return (
    <FullDate
      {...props}
      transformOutput={removeMaskSpaces}
    />
  );
};
